/**
 * Blog tag listing pages for sitemap, prerender, Amplify rules and tag chip links.
 * Every canonical tag gets a page; only tags with ≥ BLOG_TAG_MIN_INDEXABLE_POSTS posts are
 * indexable (sitemap) — the rest render `noindex, follow`. Source: scripts/generate-blog-tag-catalog.mjs.
 */
import { BLOG_TAG_PAGES } from '../data/blogTagPages.generated.js';

export { BLOG_TAG_PAGES };

export const BLOG_TAG_SLUGS = BLOG_TAG_PAGES.map((page) => page.slug);

export const BLOG_TAG_INDEXABLE_SLUGS = BLOG_TAG_PAGES.filter((page) => page.indexable).map((page) => page.slug);

export function getBlogTagPage(slug) {
  return BLOG_TAG_PAGES.find((page) => page.slug === slug) ?? null;
}
